import "./TextFeld.css";

/**
 * Einzeiliges Eingabefeld im neuen Stil. Alle Props gehen ans <input>.
 * @category eingaben
 */
export function TextFeld({ className, ...rest }) {
  return <input className={["feld", className].filter(Boolean).join(" ")} {...rest} />;
}

export default TextFeld;
